export default __webpack_public_path__ + "8c6754487f2d6798c7fe46fe682751c1.svg";